import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import { Auth } from "aws-amplify";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";
import { CONSTANTES } from "../../utils/Constantes";
import { setLocalStorage } from "../../utils/LocalStorage";
import Button from "../common/Button";
import Input from "../common/Input";
import "./styles.scss";
import { hideLoading, showLoading } from "../../redux/actions/general";
import * as AWS from "aws-sdk";
import { callService } from "../../amplify/callService";

// TODO: configurar globalmente
AWS.config.region = process.env.REACT_APP_REGION;
AWS.config.credentials = new AWS.CognitoIdentityCredentials({
  IdentityPoolId: process.env.REACT_APP_IDENTITYPOOLID,
});

const Formulario = ({
  history,
  handleIsRequiredPassword,
  handleResponseAuth,
  activeSendCodeToRestorePassword,
  handleShowAlert,
}) => {
  const dispatch = useDispatch();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  let [numIntentos, setNumIntentos] = useState(1);

  const handleChangeUsername = (value) => {
    setErrorMessage("");
    setUsername(value);
  };
  const handleChangePassword = (value) => {
    setErrorMessage("");
    setPassword(value);
  };
  const redirect = (responseAuth) => {
    setLocalStorage("user", {
      username: responseAuth.username,
      clientId: responseAuth.pool.clientId,
    });
    history.push(CONSTANTES.RUTA.home);
  };

  const handlePressEnter = (e) => {
    console.log("handler");
    if (e.key === "Enter") {
      console.log("enter key");
    }
  };

  const disableUser = async (userName) => {
    try {
      if (numIntentos === 1) {
        handleShowAlert({
          show: true,
          title: "Clave Incorrecta",
          message:"Después de 3 intentos incorrectos el acceso se bloqueará",
          type: "error",
        });
      }

      if (numIntentos === 3) {
        // disabled from mysql db
        let disabled = await callService(
          "POST",
          CONSTANTES.APIS_PATH.actionsLogin,
          {
            payload: {
              username: userName,
              action: "disabled",
            },
          }
        );
        if(disabled.data && !!disabled.data.status){
          handleShowAlert({
            show: true,
            title: "Aviso",
            message:"se ha deshabilitado el usuario, contactar al administrador del sistema",
            type: "error",
          });
        }
        // disable from cognito
        let cognitoidentityserviceprovider =
          new AWS.CognitoIdentityServiceProvider({ apiVersion: "latest" });
        let params = {
          UserPoolId: process.env.REACT_APP_USERPOOLID,
          Username: userName,
        };
        let response = await cognitoidentityserviceprovider
          .adminDisableUser(params)
          .promise();
        console.log("disabled cognito ", response);
      }
    } catch (ex) {
      dispatch(hideLoading());
      console.log("Error: ", ex);
    }
  };
 
  const verifyUser = async (username) => {
    try {
      let response = await callService(
        "POST",
        CONSTANTES.APIS_PATH.actionsLogin,
        {
          payload: {
            username,
            action: "verifyuser",
          },
        }
      );
      console.log('verifyuser', response);
      if (response.ok && response.data) {
        return response.data.count;
      }

      return 0;
    } catch (ex) {
      dispatch(hideLoading());
      console.log("Error: ", ex);
    }
  };

  const login = async (e) => {
    e.preventDefault();
    dispatch(showLoading());
    try {
      /* 
      const count = await verifyUser(username.trim());
      // verificar usuario existe en mysql db
      if (count <= 0) {
        dispatch(hideLoading());
        handleShowAlert({
          show: true,
          title: "Aviso",
          message:"El usuario no existe o esta deshabilitado",
          type: "error",
        });
        return;
      }
      */
      let responseAuth = await Auth.signIn(username.trim(), password.trim());
      if (responseAuth.challengeName === CONSTANTES.NEW_PASSWORD_REQUIRED) {
        dispatch(hideLoading());
        handleIsRequiredPassword(true);
        handleResponseAuth(responseAuth);
      } else {
        dispatch(hideLoading());
        redirect(responseAuth);
      }
    } catch (error) {
      dispatch(hideLoading());
      console.error("ERROR SIGN:", error);
      debugger;
      if ("UserNotConfirmedException" === error.code) {
        setErrorMessage(
          "Usuario requiere confirmación del registro antes de Loguear"
        );
      } else if ("PasswordResetRequiredException" === error.code) {
        setErrorMessage("Se requiere restablecer la contraseña");
      } else if ("NotAuthorizedException" === error.code) {
          // await disableUser(username.trim())
          // setNumIntentos(numIntentos + 1);
        if (error.message.toLowerCase().includes("temporary password"))
          setErrorMessage(
            "La clave temporal ha expirado, por favor comuniquesé con su adiministrador para resetear la clave y volver a intentar"
          );
        else  if (error.message.toLowerCase().includes("user is disabled"))
          setErrorMessage(
            "Su usuario se encuentra deshabilitado por haber pasado el límite de intentos. Contáctese con el administrador."
          );
        else  if (error.message.toLowerCase().includes("incorrect username or password"))
        {
          let mensaje= "";
          const body = {
            payload: {
              username: username.trim()
            },
          };
          try {
            dispatch(showLoading());
            const response = await callService(
              "POST",
              CONSTANTES.APIS_PATH.lockUser,
              body
            );
            dispatch(hideLoading());
            // type == 0 => ok , type == 1 => error
            let error = response.data? response.data.type:null;
            debugger;
            if (response.ok && response.data && response.ok == true && error!='1') {
              const mesaje = response.message || "OK";
              mensaje =response.data.data    || response.message   || "Los datos ingresados son incorrectos, por favor verifícalos y vuelve a intentar";

            } else {
              const mesaje = response.message || "Error al registrar";
              mensaje ="Los datos ingresados son incorrectos, por favor verifícalos y vuelve a intentar";

            }
          } catch (ex) {
            console.log(ex)
            dispatch(hideLoading());
            mensaje = "Los datos ingresados son incorrectos, por favor verifícalos y vuelve a intentar";
          }
          console.log(mensaje);
          debugger;
          setErrorMessage(
            mensaje
          );
        }
        else
          setErrorMessage(
            "Los datos ingresados son incorrectos, por favor verifícalos y vuelve a intentar"
          );
      } else if ("UserNotFoundException" === error.code) {
        setErrorMessage(
          "Los datos ingresados son incorrectos, por favor verifícalos y vuelve a intentar"
        );
      } else if ("InvalidPasswordException" === error.code) {
        setErrorMessage("El formato de contraseña es inválido.");
      } else if (
        "UserLambdaValidationException" === error.code &&
        error.message.includes("REINTENTAR")
      ) {
        login();
      } else {
        setErrorMessage(
          "Ocurrió un error al autenticar. Contacte al administrador"
        );
      }
    }
  };

  const handleRestorePassword = () => {
    const userData = { username, password };
    activeSendCodeToRestorePassword(userData);
  };

  return (
    <form onSubmit={login} className="formulario d-justify-content">
      <h4 className="title-06">Usuarios Proveedor</h4>
      <Input
        label="Usuario"
        value={username}
        onChange={(newValue) => handleChangeUsername(newValue)}
        onKeyDown={handlePressEnter}
      />
      <Input
        label="Contraseña"
        value={password}
        type="password"
        onChange={(newValue) => handleChangePassword(newValue)}
        onKeyDown={handlePressEnter}
      />
      {errorMessage && (
        <div className="formulario_error">
          <p className="color-red title-09">{errorMessage}</p>
        </div>
      )}
      <div className="formulario_forgot text-right">
        <p className="title-08 pointer" onClick={() => handleRestorePassword()}>
          Restablecer Contraseña
        </p>
      </div>
      <Button primary onClick={login} disabled={(numIntentos > 3)}>
        INGRESAR A MI CUENTA
      </Button>
    </form>
  );
};

Formulario.propTypes = {
  handleIsRequiredPassword: PropTypes.func,
  handleResponseAuth: PropTypes.func,
  activeSendCodeToRestorePassword: PropTypes.func,
  showAlert: PropTypes.func,
};

Formulario.defaultProps = {
  handleIsRequiredPassword: null,
  handleResponseAuth: null,
  activeSendCodeToRestorePassword: null,
  showAlert: null,
};

export default withRouter(Formulario);
